import { render, staticRenderFns } from "./ReviewAndSubmit.vue?vue&type=template&id=4ce89893&"
import script from "./ReviewAndSubmit.vue?vue&type=script&lang=js&"
export * from "./ReviewAndSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports